import 'readmore-js';
import {moreLink, lessLink} from './readmore-link';

export function initReadmoreReviews() {
    let $items = $('.reviews-item .description .content');

    if ($items.length > 0) {
        $items.each(function () {
            $(this).readmore({
                moreLink: moreLink(),
                lessLink: lessLink(),
            });
        });
    }
}
